import Cookies from "js-cookie";
import AuthTokenService from "../service/authTokenService";

export default class AuthorizationHelper {

    constructor() {
        this.authTokenService = new AuthTokenService();
    }

   async checkAccessTokenAndRefresh(){
        if (Cookies.get("access_token") !== undefined){
            return true;
        } 
        
        if(Cookies.get("refresh_token") === undefined){
            return false;
        }

        var refreshValue = await this.authTokenService.refreshAccessToken(Cookies.get("refresh_token"))

        if(refreshValue !== undefined){
            var access_token_cookie_options = {};
            access_token_cookie_options.expires = new Date(Date.now() + ((refreshValue.expires - 30 /* -30 minutes*/ * 60) * 1000));
            Cookies.set("access_token", refreshValue.access_token,access_token_cookie_options);
            var refresh_token_cookie_options = {};
            refresh_token_cookie_options.expires = new Date(Date.now() + 30 /*days*/ * 24 * 60 * 60* 1000);
            Cookies.set("refresh_token", refreshValue.refresh_token,refresh_token_cookie_options);
        }
        return true;
    }

    async loginUser(userName, password){
        console.log("Logging in");
        let results = await this.authTokenService.loginUser(userName, password);
        console.log("Logging in");

        if (results.status === 401) {
            alert("Wrong username or password");
            
            return false;
        }
        else {
            var access_token_cookie_options = {};
            access_token_cookie_options.expires = new Date(Date.now() + ((results.expires - 30 /* -30 minutes*/ * 60) * 1000));
            Cookies.set("access_token", results.access_token,access_token_cookie_options);
            var refresh_token_cookie_options = {};
            refresh_token_cookie_options.expires = new Date(new Date() + 30 /*days*/ * 24 * 60 * 60* 1000);
            Cookies.set("refresh_token", results.refresh_token,refresh_token_cookie_options);
        }
        return true;
    }
}